<template>
  <div id="platfrom_home">
    <div class="fix_header">
      <home_menu
        v-if="homeMenu_groupList"
        :userInfor="homeMenu_userInfor"
        :groupList="homeMenu_groupList"
        :currGroup="homeMenu_currGroup"
        @changeGroupEvent="homeMenu_changeGroup"
        :menuData="homeMenu_competTypeList"
        @clickMenuEvent="homeMenu_clickMenu"
      ></home_menu>
    </div>
    <div class="compet_main">
      <span class="compet_item" v-for="item in competList" :key="item.id">
        <span
          class="competItem_box"
          @click="goComptPage(item)"
          :style="{ backgroundImage: `url(${item.logo ? item.logo : ''})` }"
        >
          <span class="competItem_shortName" v-text="item.abbName"></span>
          <span class="competItem_fullName" v-text="item.name"></span>
          <span
            v-show="item.status * 1 === 0"
            class="competItem_noclick"
            @click.stop="noClick()"
          >
            权限未开通
          </span>
          <!-- 权限未开通 0：未拥有 1：已拥有 2：敬请期待 -->
          <span
            v-show="item.status * 1 === 2"
            class="competItem_expect"
            @click.stop="noClick()"
          >
            敬请期待
          </span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import {
  https_manage_getGroupData,
  https_home_getAllCompet,
  https_home_getCompetitionByCategory,
} from '@api/platfrom_base_api'
import home_menu from '@components/platfromBase/home/home_menu.vue'

export default {
  name: 'platfrom_home',
  components: { home_menu },
  data() {
    return {
      homeMenu_groupList: null,
      homeMenu_userInfor: {
        companyName: '',
        email: '',
        identy: '',
        role: '',
        station: null,
        stationName: '',
        userAlias: '',
        userId: '',
      },
      homeMenu_currGroup: null,
      homeMenu_competTypeList: null,
      currCompetType: null,
      competList: null,
    }
  },
  created() {
    const userInfor = JSON.parse(this.$localStorage.getItem('mixtmt_userInfo'))
    if (userInfor) {
      this.homeMenu_userInfor = userInfor
    }
    console.debug(this.homeMenu_userInfor)
    console.debug('route:', this.$route)

    this.createdOnce()
  },
  methods: {
    async createdOnce() {
      await this.getGroupData()
      await this.init()
    },
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      if (this.homeMenu_currGroup) {
        await this.getAllCompet()
      }
      if (this.currCompetType) {
        await this.getCompetitionByCategory({
          categoryId: this.currCompetType.id,
          groupId: this.homeMenu_currGroup.groupId,
        })
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async homeMenu_clickMenu(item) {
      const competTypeItem = this.homeMenu_competTypeList[0]
      const arr = competTypeItem.arr.map((val) => {
        if (item.key === val.key) {
          val.act = true
        } else {
          val.act = false
        }
        return val
      })
      this.homeMenu_competTypeList = [
        {
          name: competTypeItem.name,
          arr,
        },
      ]
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getCompetitionByCategory({
        categoryId: item.id,
        groupId: this.homeMenu_currGroup.groupId,
      })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    homeMenu_changeGroup(item) {
      this.homeMenu_groupList.forEach((val) => {
        if (item.groupId == val.groupId) {
          val.act = true
        } else {
          val.act = false
        }
      })
      this.homeMenu_currGroup = item
      window.mixtmt_platfrom.currGroup = item
      this.init()
    },
    goComptPage(item) {
      console.debug('goComptPage:', item)
      let pathName = null,
        pathUrl = null,
        currCidKey = null
      if (item.sportType === 'football') {
        // 足球
        // [亚洲世预赛|足球世界杯|联赛赛事 CSL]
        const cidArr = ['112', '109', '108']
        const abbNameArr_En = ['FIFAWCQAZ', 'FIFAWC', 'FBLCSL']
        const modulePathModuleArr = ['WCQAsianZone', 'FIFAWorldCup', 'FBLCSL']
        const indexNo = cidArr.indexOf(item.id)
        if (typeof indexNo === 'number') {
          if (indexNo > 0) {
            // 其他
            pathName = `scheduleIndex_${abbNameArr_En[indexNo]}`
          } else {
            // 亚洲世预赛
            pathName = `zonePreScheduleIndex_${abbNameArr_En[indexNo]}`
          }
          pathUrl = ['football', modulePathModuleArr[indexNo], 'schedule']
        }
      } else if (item.sportType === 'marathon') {
        // 马拉松
        const cidArr = ['301']
        const abbNameArr_En = ['Hengqin'] // 【横琴马拉松】
        const modulePathModuleArr = ['HengqinMara']
        const indexNo = cidArr.indexOf(item.id)
        if (typeof indexNo === 'number') {
          pathName = `marathonSignupIndex_${abbNameArr_En[indexNo]}`
          pathUrl = ['marathon', modulePathModuleArr[indexNo], 'signup']
        }
      } else if (item.sportType === 'compreSportsMeet') {
        //综合性赛事 ['大运会','亚运会','奥运会','亚冬会', '全运会', '米兰冬奥会']
        const cidArr = ['WUSG', 'ASG', 'SOG', 'AWG', 'NSG', 'WOG']
        const abbNameArr_En = ['WUSG', 'ASG', 'SOG', 'AWG', 'NSG', 'WOG']
        const modulePathModuleArr = [
          'universiades',
          'asianGames',
          'olympicGames',
          'asianWinterGames',
          'nationalGames',
          'milanWinterGames',
        ]

        const indexNo = cidArr.indexOf(item.id)
        if (typeof indexNo === 'number') {
          pathName = `CSMeetRegularScheduleIndex_${abbNameArr_En[indexNo]}`
          pathUrl = [
            'compreSportsMeet',
            modulePathModuleArr[indexNo],
            'schedule',
          ]
        }
      } else if (item.sportType === 'basketball') {
        // 篮球联赛
        const cidArr = ['201', '202', '203']
        const abbNameArr_En = ['CBA', 'FIBAWA', 'FIBAMA'] // 【CBA|FIBAWA|FIBAMA】
        const modulePathModuleArr = [
          'CBA',
          'FIBAWomenAsiaCup',
          'FIBAManAsiaCup',
        ]
        const indexNo = cidArr.indexOf(item.id)
        console.debug('indexNo:', indexNo)
        if (typeof indexNo === 'number') {
          pathName = `scheduleIndex_${abbNameArr_En[indexNo]}`
          pathUrl = ['basketball', modulePathModuleArr[indexNo], 'schedule']
        }
      } else if (item.sportType === 'badminton') {
        // 羽毛球
        const cidArr = ['503', '504']
        const abbNameArr_En = ['BDMTAU', 'BDMSC'] // 【汤尤杯|苏迪曼杯】
        const modulePathModuleArr = ['thomasAndUber', 'sudirman']
        const indexNo = cidArr.indexOf(item.id)
        if (typeof indexNo === 'number') {
          pathName = `${item.sportType}ScheduleIndex_${abbNameArr_En[indexNo]}`
          pathUrl = ['badminton', modulePathModuleArr[indexNo], 'schedule']
        }
      } else if (item.sportType === 'tennis') {
        //网球: ['中国网球公开赛']
        const cidArr = ['601']
        const abbNameArr_En = ['TENCO']
        const modulePathModuleArr = ['chinaOpen']
        const indexNo = cidArr.indexOf(item.id)
        if (typeof indexNo === 'number') {
          pathName = `${item.sportType}ScheduleIndex_${abbNameArr_En[indexNo]}`
          pathUrl = ['tennis', modulePathModuleArr[indexNo], 'schedule']
        }
      }

      if (pathName) {
        currCidKey = pathUrl[1]
        let currSeasonMap = JSON.parse(
          this.$localStorage.getItem('mixtmt_platfromV4_currSeasonMap')
        )
        if (!currSeasonMap) {
          currSeasonMap = {}
        }
        currSeasonMap[currCidKey] = {
          cid: item.id,
          competitionType: item.competitionType,
        }
        // 存储当前cid，为了解决最外层页面刷新时无法获取到cid准备的
        this.$localStorage.setItem(
          'mixtmt_platfromV4_currSeasonMap',
          JSON.stringify(currSeasonMap)
        )
        console.debug('pathName:', pathName, pathUrl)
        this.pageJump(this.$router, pathName, {
          pathUrl,
        })
      }
    },
    noClick() {
      console.debug('权限未开通或敬请期待')
    },
    // pageJump(routerName, query, params) {
    //   // window.bj2022Opt.currLoadingPage = routerName;
    //   // window.mixtmtBase_eventBus.$emit("loadingEvent", true);
    //   var url = window.location.href //获取url中"?"符后的字串
    //   var newQuery = {}
    //   if (url.indexOf('?') > -1) {
    //     var str = url.substring(url.indexOf('?') - 0 + 1)
    //     const strs = str.split('&')
    //     for (var i = 0; i < strs.length; i++) {
    //       newQuery[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
    //     }
    //   }
    //   console.debug(
    //     `pageJump: ${routerName}, query: ${JSON.stringify(
    //       query
    //     )}, newQuery: ${JSON.stringify(newQuery)}`
    //   )
    //   const VUE_APP_H5URL = process.env.VUE_APP_H5URL
    //   let pushObj
    //   if (query) {
    //     pushObj = {
    //       name: routerName,
    //       // path: url
    //       query: query,
    //       params: params ? params : {},
    //     }
    //   } else {
    //     pushObj = {
    //       name: routerName,
    //     }
    //   }
    //   window.mixtmtBase_eventBus.$emit('loadingEvent', true)
    //   this.$router.push(pushObj)
    // },
    async getGroupData() {
      await https_manage_getGroupData('/api', this.$axios)
        .then((response) => {
          const res = response.data
          console.debug('正常')
          if (res.status === 0) {
            this.homeMenu_groupList = res.data
              ? res.data.map((item, index) => {
                  if (index == 0) {
                    item.act = true
                    this.homeMenu_currGroup = item
                    window.mixtmt_platfrom.currGroup = item
                  } else {
                    item.act = false
                  }
                  return item
                })
              : []
            this.$localStorage.setItem(
              'mixtmt_groupList',
              JSON.stringify(res.data)
            )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getAllCompet() {
      await https_home_getAllCompet('/api', this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            const competTypeList = res.data
              ? res.data.map((item, index) => {
                  item.key = `compet_${item.id}`
                  if (index == 0) {
                    item.act = true
                    this.currCompetType = item
                  }
                  return item
                })
              : []
            this.homeMenu_competTypeList = [
              {
                name: 'webMenu',
                arr: competTypeList,
              },
            ]
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getCompetitionByCategory(params) {
      await https_home_getCompetitionByCategory('/api', this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.competList = res.data ? res.data : []
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#platfrom_home {
  & .fix_header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 8vw;
    background-color: #fff;
  }
  & .compet_main {
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    padding: 10.083vw 9.722vw 4.16vw 9.722vw;
    width: 100%;
    height: auto;
    .compet_item {
      position: relative;
      margin: 0 1.736vw 1.736vw 0;
      width: calc((100% - (1.736vw * 2)) / 3);
      height: auto;
      background-color: #ccc;
      color: #fff;
      font-weight: bold;
      -webkit-transition: -webkit-transform 0.1s linear;
      transition: -webkit-transform 0.1s linear;
      transition: transform 0.1s linear;
      transition: transform 0.1s linear, -webkit-transform 0.1s linear;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .competItem_box {
        position: relative;
        display: block;
        width: 100%;
        padding-top: 59.5%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        .competItem_shortName {
          position: absolute;
          left: 0;
          bottom: 34%;
          width: 30%;
          height: 2.778vw;
          line-height: 2.778vw;
          padding: 0 0 0 1.388vw;
          border-radius: 0 1.388vw 1.388vw 0;
          font-size: 1.111vw;
          background: rgba(0, 0, 0, 0.4);
        }
        .competItem_fullName {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 4.166vw;
          font-size: 1.25vw;
          line-height: 4.166vw;
          padding: 0 1.388vw;
          background: rgba(0, 0, 0, 0.4);
        }
        .competItem_noclick,
        .competItem_expect {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 60;
          width: 100%;
          height: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          background: rgba(0, 0, 0, 0.7);
          font-size: 1.388vw;
          font-weight: bold;
        }
        .competItem_expect {
          color: #333;
          background: hsla(0, 0%, 100%, 0.7);
        }
      }
    }
  }
}
.mixtmt_pc #platfrom_home {
  .compet_main {
    .compet_item {
      &:hover {
        cursor: pointer;
        -webkit-transform: translateY(-0.278vw);
        transform: translateY(-0.278vw);
        -webkit-box-shadow: 2px 4px 16px 3px rgb(0 0 0 / 20%);
        box-shadow: 2px 4px 16px 3px rgb(0 0 0 / 20%);
      }
    }
  }
}
</style>
